//export enum ParameterType {
//  Integer = 0, //"Integer",
//  String = 1, //"String"
//  Dropdown = 2,
//  Multiselect = 3
//}

export enum ParameterType {
  Integer = "Integer",
  String = "String",
  Dropdown = "Dropdown",
  Multiselect = "Multiselect"
}
